"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../../actions/");
const reducers_1 = require("../../../../reducers/");
const src_1 = require("@rover/ts-bootstrap/dist/src/");
const RichMediaSelector = ({ closePopoverModalForm, device, isEditingRichMediaURL, richMediaAttachmentTab, updateActivePopover, updateNotificationDeliverable, updateEditingField, updateRichMediaAttachmentTab, updateTempNotificationAttachmentFields, tempNotificationAttachment, }) => {
    const type = tempNotificationAttachment ? tempNotificationAttachment.type : 'IMAGE';
    const url = tempNotificationAttachment ? tempNotificationAttachment.url : '';
    const getMediaDescription = () => {
        switch (richMediaAttachmentTab) {
            case 'IMAGE':
                return 'Images can be in JPG, GIF or PNG format. Transparent backgrounds are not recommended.';
            case 'AUDIO':
                return 'Audio clips can be in AIFF, WAV, MP3 or M4A format.';
            case 'VIDEO':
            default:
                return 'Video clips can be in MPEG, MPEG2, MP4 or AVI format.';
        }
    };
    const close = () => {
        switch (device) {
            case 'Mobile':
                closePopoverModalForm();
                setTimeout(() => {
                    updateActivePopover('');
                }, 500);
                break;
            case 'Desktop':
            case 'Tablet':
            default:
                updateActivePopover('');
                break;
        }
    };
    const dividerLine = () => (React.createElement("div", { style: {
            height: 1,
            width: device !== 'Mobile' ? 352 : '100%',
            background: src_1.titanium,
        } }));
    const Fragment = React.Fragment;
    return (React.createElement(Fragment, null,
        device === 'Mobile' && (React.createElement("div", { style: {
                margin: 24,
                marginBottom: 8,
            } },
            React.createElement(src_1.Text, { size: "h1", text: "Add Attachment" }))),
        React.createElement(src_1.TabBar, null,
            React.createElement(src_1.Tab, { val: 'Image', selected: richMediaAttachmentTab[0] + richMediaAttachmentTab.slice(1).toLowerCase(), onClick: () => updateRichMediaAttachmentTab('IMAGE', '') }),
            React.createElement(src_1.Tab, { val: 'Audio', selected: richMediaAttachmentTab[0] + richMediaAttachmentTab.slice(1).toLowerCase(), onClick: () => updateRichMediaAttachmentTab('AUDIO', '') }),
            React.createElement(src_1.Tab, { val: 'Video', selected: richMediaAttachmentTab[0] + richMediaAttachmentTab.slice(1).toLowerCase(), onClick: () => updateRichMediaAttachmentTab('VIDEO', '') })),
        React.createElement("div", { style: {
                padding: device === 'Mobile' ? '0px 24px 24px 24px' : `16px 16px 0 16px`,
                width: device !== 'Mobile' ? 384 : '100%',
            } },
            React.createElement(src_1.Text, { size: device === 'Mobile' ? 'medium' : 'small', text: getMediaDescription(), textStyle: {
                    margin: device === 'Mobile' ? '24px 0 23px 0' : '0 0 15px 0',
                    width: device !== 'Mobile' ? 352 : '100%',
                } }),
            dividerLine(),
            React.createElement(src_1.TextInput, { id: "notification-rich-media-attachment", isRequired: true, deleteText: () => {
                    updateNotificationDeliverable({
                        attachment: null,
                    });
                    updateTempNotificationAttachmentFields({
                        type: 'IMAGE',
                        url: '',
                    });
                }, fieldStyle: {
                    padding: device === 'Mobile' ? '24px 0 23px' : '16px 0 15px',
                    border: 'none',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }, isEditingText: isEditingRichMediaURL, label: "", media: device, placeholder: `Enter ${richMediaAttachmentTab.toLowerCase()} ${richMediaAttachmentTab !== 'IMAGE' ? 'clip' : ''} URL`, startEditingText: () => updateEditingField('url'), text: url && type === richMediaAttachmentTab ? url : '', handleBlurChange: (text) => {
                    if (device === 'Mobile') {
                        const url = text.trim();
                        updateEditingField('', () => {
                            updateTempNotificationAttachmentFields({
                                type: richMediaAttachmentTab,
                                url,
                            });
                        });
                    }
                }, updateText: (text) => {
                    const url = text.trim();
                    updateEditingField('', () => {
                        close();
                        updateNotificationDeliverable({
                            attachment: {
                                type: richMediaAttachmentTab,
                                url: url,
                            },
                        });
                        updateTempNotificationAttachmentFields({
                            type: richMediaAttachmentTab,
                            url: url,
                        });
                    });
                }, primaryTextSize: device === 'Mobile' ? 'large' : 'medium' }),
            device === 'Mobile' && richMediaAttachmentTab === 'IMAGE' ? dividerLine() : null,
            richMediaAttachmentTab !== 'IMAGE' && (React.createElement(React.Fragment, null,
                dividerLine(),
                React.createElement(src_1.Alert, { message: `${richMediaAttachmentTab[0] + richMediaAttachmentTab.slice(1).toLowerCase()} not supported on Android`, style: {
                        margin: device === 'Mobile' ? '24px 0' : '16px 0',
                    }, type: "warn" }))))));
};
const mapStateToProps = (state) => ({
    editableCampaign: reducers_1.getEditableCampaign(state),
});
const mapDispatchToProps = (dispatch) => ({
    closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
    updateActivePopover: (field) => dispatch(actions_1.updateActivePopover(field)),
    updateNotificationDeliverable: (x) => dispatch(actions_1.updateNotificationDeliverable(x)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(RichMediaSelector);
